import { Message } from "element-ui";
import { MessageBox } from 'element-ui';
import http from "@/api/config";
import errorMessage from "@/assets/common/errorMessage";
import { saveAs } from "file-saver";

const noErrorCodes = [200, 400, 600];

export const easyHttp = function(config) {
	return http(config)
		.then((resp) => {
			const serverData = resp.data;
			if ( serverData && serverData.hasOwnProperty("code") && serverData.hasOwnProperty("msg") ) {
                if(!noErrorCodes.includes(serverData.code)) {
                    Message.error(serverData.msg);
                }
			}
			return serverData;
		})
		.catch((e) => {
			Message.error(errorMessage.SEVER_ERROR);
		});
};

export const get = function(url, params) {
	const requestConfig = {
		method: "GET",
		url: url,
		params: params || {},
	};
	return easyHttp(requestConfig);
};

export const post = function(url, data) {
	const requestConfig = {
		method: "POST",
		url: url,
		data: data || {},
	};
	return easyHttp(requestConfig);
};

export const put = function(url, data) {
	const requestConfig = {
		method: "PUT",
		url: url,
		data: data || {},
	};
	return easyHttp(requestConfig);
};

export const del = function(url, params, data) {
	const requestConfig = {
		method: "DELETE",
		url: url,
		params: params || {},
		data: data || {},
	};
	return easyHttp(requestConfig);
};

export const upload = function(url, files) {
	let data = new FormData();
	// 上传文件对象 名称file与后台控制器参数要一致
	data.append("file", files);
	const requestConfig = {
		method: "POST",
		// 上传地址
		url: url,
		// 定义上传头
		headers: { "Content-Type": "multipart/form-data" },
		data: data,
	};
	return easyHttp(requestConfig);
};

export const download = function(url, params, fileName) {
	return doDownload('GET', url, params, fileName);
};

export const downloadPost = function(url, data, fileName) {
	return doDownload('POST', url, data, fileName);
};

const doDownload = function(method, url, data, clientFileName) {

    const requestConfig = {
		method: method,
		url: url,
		responseType: "blob",
	};
    if(method == 'GET') {
        requestConfig.params = data || {};
    }
    if(method == 'POST') {
        requestConfig.data = data || {};
    }

	return http(requestConfig)
		.then((resp) => {
            let fileName = '未知';

			try {
                const contentDisposition = resp.origin.headers["content-disposition"];
                const serverFileName = decodeURIComponent(contentDisposition.split("filename=")[1]);
                fileName = serverFileName;
            }catch(e) {
                console.log('====================================');
                console.log('无法获取服务的返回的文件名称', e);
                console.log('====================================');
                if(clientFileName) {
                    fileName = clientFileName;
                }
            };
            const contentType = resp.origin.headers["content-type"];
			const blob = new Blob([resp.data], {type: contentType});
			saveAs(blob, fileName);
			Message.success("下载成功！");
		})
		.catch(() => {
			Message.error(errorMessage.SEVER_ERROR);
		});
}

export const alertMultiMessage = function(data, duration) {
    if(!data || !data.hasOwnProperty('data'))return;
	let messages = data.data;
	if (messages instanceof Array) {
		messages = messages.map((item) => {
            let message = '';
            if(item.hasOwnProperty('ok') && item.hasOwnProperty('message')) {
                const color = item.ok? 'green': 'red';
                const icon = item.ok? 'success': 'el-icon-error';
                message = `<p style="margin: 0px 10px; color: ${color}">${item.message}</p>`;
                return message;
            }else {
                const color = 'red';
                const icon = 'el-icon-error';
                message = `<p style="margin: 0px 10px; color: ${color}">${item}</p>`;
                return message;
            }
        }).filter((item) => item);
        if(messages.length != 0) {
            const msg = messages.join("<br/>");
            Message({
                dangerouslyUseHTMLString: true,
                duration: duration || 3000,
                showClose: true,
                message: msg,
                type: getType(data),
            });
            return;
        }
	}
    alertSingleMessage(data);
};

export const alertMessageBox = function(data) {
    if(!data || (!data.hasOwnProperty('data')) && !data.hasOwnProperty('msg') )return;
    const title = data.msg;
	let messages = data.data;
	if (messages instanceof Array) {
		messages = messages.map((item) => {
            let message = '';
            if(item.hasOwnProperty('ok') && item.hasOwnProperty('message')) {
                const color = item.ok? 'green': 'red';
                const icon = item.ok? 'success': 'el-icon-error';
                message = `<p style="margin: 0px 10px; color: ${color}"><i class="${icon}"/>${item.message}</p>`;
                return message;
            }else {
                const color = 'red';
                const icon = 'el-icon-error';
                message = `<p style="margin: 0px 10px; color: ${color}">${buildMessage(item)}</p>`;
                return message;
            }
        }).filter((item) => item);
        if(messages.length != 0) {
            const msg = messages.join("<br/>");
            MessageBox({
                dangerouslyUseHTMLString: true,
                title: title,
                message: msg
            });
            return;
        }
	}
    alertSingleMessageBox(data, title);
};

export const buildMessage = function(message) {
    const split = message.split(':');
    const div = document.createElement("div");
    const dl = document.createElement("dl");
    dl.style.color = 'red';
    const dt = document.createElement("dt");
    if(split && split.length > 0) {
        dt.innerText = split[0];
    }
    dl.appendChild(dt);
    if(split && split.length > 1) {
        
        const messages = split[1].split(";");
        for(let i = 0; i < messages.length; i++) {
            const dd = document.createElement("dd");
            dd.innerText = messages[i];
            dd.style.marginLeft = '20px';
            dl.appendChild(dd);
        }
    }
    div.appendChild(dl);
    return div.innerHTML;
}

export const alertSingleMessage = function(data) {
	Message({
		message: data.msg,
		type: getType(data),
	});
};

export const alertSingleMessageBox = function(data, title) {
	Message({
        title: title || '提示',
		message: data.msg,
		type: getType(data),
	});
};

export const getType = function(data) {
	switch (data.code) {
		case 200:
			return "success";
		case 400:
			return "error";
		case 500:
			return "error";
		case 600:
			return "error";
	}
};

/**
* [获取URL中的参数名及参数值的集合]
* 示例URL:http://htmlJsTest/getrequest.html?uid=admin&rid=1&fid=2&name=小明
* @param {[string]} urlStr [当该参数不为空的时候，则解析该url中的参数集合]
* @return {[string]}       [参数集合]
*/
export const getParams = function (urlStr) {
    const url = new URL(urlStr);
    const search = url.search;
    const theRequest = new Object();
    if(search) {
        const paramsStr = search.substr(1);
        let paramsArray = paramsStr.split("&");
        for(var i = 0; i < paramsArray.length; i ++) {
            theRequest[paramsArray[i].split("=")[0]]=unescape(paramsArray[i].split("=")[1]);
        }
    }
    return theRequest;
}
